/* ==========================================================================
   custom.js - complete file. Replace the ENTIRE contents of assets/custom.js
   with everything below (Ctrl+A, then paste). Five independent blocks:
     1. Uniform product covers (collection grid cover-fit)
     2. Product gallery lightbox
     3. Product page: subtitle moved under the title
     4. Sale badge >= 15% threshold
     5. Binding + Language: uniform labels/values
   ========================================================================== */

/* Uniform product covers ---------------------------------------------------
   Covers use object-fit:cover so every tile is the same shape. That crops, and
   a handful of catalogue images (landscape "bundle" shots of two books side by
   side) lose so much that the crop lands on the white gap between the books and
   the card renders as a blank white tile.

   This flags any image that would lose more than MAX_CROP and lets CSS fall
   back to object-fit:contain for just those. Pairs with the .img-fit-contain
   rule in the PART 4 block of assets/theme.css.

   Measured on this catalogue: 372 products, ~52 fall back to contain.
   --------------------------------------------------------------------------- */
(function () {
  var FRAME_RATIO = 2 / 3;   // the .aspect-ratio box is 2:3
  var MAX_CROP = 0.12;       // 12% - raise to crop more, lower to crop less

  function fit(img) {
    if (!img.naturalWidth || img.dataset.fitChecked) return;
    img.dataset.fitChecked = '1';
    var ar = img.naturalWidth / img.naturalHeight;
    var crop = ar > FRAME_RATIO ? 1 - FRAME_RATIO / ar : 1 - ar / FRAME_RATIO;
    if (crop > MAX_CROP) img.classList.add('img-fit-contain');
  }

  function scan() {
    var imgs = document.querySelectorAll(
      '.product-list .product-item__primary-image, .product-list .product-item__secondary-image'
    );
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.complete) {
        fit(img);
      } else {
        img.addEventListener('load', function () { fit(this); }, { once: true });
      }
    }
  }

  var queued;
  function scanSoon() {
    clearTimeout(queued);
    queued = setTimeout(scan, 100);
  }

  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);

  // Collection filtering, pagination and the carousels swap cards in via AJAX.
  // childList only - so adding the class below never re-triggers this observer.
  new MutationObserver(scanSoon).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();



/* Product gallery lightbox -------------------------------------------------
   Warehouse ships Drift (data-zoom / data-zoom-width on .product-gallery__image),
   which magnifies a small region under the cursor. That works for inspecting a
   detail, but it is useless for reading a back cover: you get a moving keyhole
   over body text instead of the whole page.

   This adds click-to-open: the image opens full-screen, fit to the viewport,
   with prev/next across the product's images, click-to-zoom-to-100% + drag to
   pan, and pinch/swipe on touch. Drift is left alone and keeps working on hover.

   NOTE ON SOURCE RESOLUTION
   Most covers in this catalogue are uploaded small - median master is ~354px
   wide, and 277 of 341 images are under 600px. The lightbox requests the
   largest size Shopify will serve (2048px), but Shopify never upscales, so a
   333px master opens as 333px stretched to fit. This makes hi-res images
   genuinely readable; it cannot invent detail that was never uploaded.

   Pairs with the lightbox block in assets/theme.css.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var GALLERY   = '.product-gallery__carousel--zoomable';
  var SLIDE     = '.product-gallery__carousel-item[data-media-type="image"]';
  var SRC_WIDTH = 2048;  // Shopify's largest standard transform
  var DRAG_SLOP = 8;     // px of movement that turns a click into a Flickity drag

  var overlay, imgEl, stage, counter, prevBtn, nextBtn;
  var slides = [], index = 0, openedFrom = null;
  var scale = 1, panX = 0, panY = 0, minScale = 1, maxScale = 1;
  var suppressClick = false;

  /* --- helpers ------------------------------------------------------------ */

  // Ask the CDN for a specific width. Shopify won't upscale, so this is a
  // ceiling rather than a resize: small masters come back at their own size.
  function sized(url, w) {
    if (!url) return url;
    if (url.indexOf('//') === 0) url = window.location.protocol + url;
    return url.replace(/(\.(?:jpe?g|png|webp|gif))(\?|$)/i, '_' + w + 'x$1$2');
  }

  // Best available source for a gallery <img>: Drift's data-zoom is the
  // untransformed master, so prefer it over the (already shrunk) src.
  function bestSrc(img) {
    return sized(img.getAttribute('data-zoom') || img.currentSrc || img.src, SRC_WIDTH);
  }

  /* --- overlay construction ----------------------------------------------- */

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'pl-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Product image viewer');
    overlay.innerHTML =
      '<button class="pl-close" type="button" aria-label="Close image viewer">&times;</button>' +
      '<button class="pl-nav pl-nav--prev" type="button" aria-label="Previous image"></button>' +
      '<button class="pl-nav pl-nav--next" type="button" aria-label="Next image"></button>' +
      '<div class="pl-stage"><img class="pl-image" alt=""></div>' +
      '<div class="pl-counter" aria-live="polite"></div>';

    stage   = overlay.querySelector('.pl-stage');
    imgEl   = overlay.querySelector('.pl-image');
    counter = overlay.querySelector('.pl-counter');
    prevBtn = overlay.querySelector('.pl-nav--prev');
    nextBtn = overlay.querySelector('.pl-nav--next');

    overlay.querySelector('.pl-close').addEventListener('click', close);
    prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn.addEventListener('click', function () { go(1); });

    // Backdrop click closes; clicks on the image itself must not bubble up to it.
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target === stage) close();
    });

    // Click the image to zoom, click the backdrop to close. suppressClick is set
    // by the pan handler so that releasing a drag doesn't also toggle the zoom.
    imgEl.addEventListener('click', function (e) {
      e.stopPropagation();
      if (suppressClick) { suppressClick = false; return; }
      toggleZoom(e);
    });
    imgEl.addEventListener('dblclick', function (e) { e.preventDefault(); });

    bindZoomAndPan();
    document.body.appendChild(overlay);
  }

  /* --- zoom + pan ---------------------------------------------------------- */

  function applyTransform() {
    imgEl.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
    overlay.classList.toggle('is-zoomed', scale > minScale + 0.01);
  }

  function resetZoom() {
    scale = minScale = 1;
    panX = panY = 0;
    // How far we can zoom before hitting the image's real pixels. Small masters
    // still get a little headroom so the control never feels dead.
    var natural = imgEl.naturalWidth || 1;
    var shown   = imgEl.clientWidth || 1;
    maxScale = Math.max(2, Math.min(6, natural / shown));
    applyTransform();
  }

  // Keep the image from being dragged entirely off-screen.
  function clampPan() {
    var r = imgEl.getBoundingClientRect();
    var overX = Math.max(0, (r.width  - window.innerWidth)  / 2);
    var overY = Math.max(0, (r.height - window.innerHeight) / 2);
    panX = Math.max(-overX, Math.min(overX, panX));
    panY = Math.max(-overY, Math.min(overY, panY));
  }

  function zoomTo(next, originX, originY) {
    next = Math.max(minScale, Math.min(maxScale, next));
    if (next === scale) return;
    // Zoom about the pointer: keep the point under the cursor stationary.
    var r = imgEl.getBoundingClientRect();
    var cx = originX - (r.left + r.width  / 2);
    var cy = originY - (r.top  + r.height / 2);
    var ratio = next / scale;
    panX -= cx * (ratio - 1);
    panY -= cy * (ratio - 1);
    scale = next;
    clampPan();
    applyTransform();
  }

  function toggleZoom(e) {
    if (scale > minScale + 0.01) {
      scale = minScale; panX = panY = 0; applyTransform();
    } else {
      zoomTo(maxScale, e.clientX, e.clientY);
    }
  }

  function bindZoomAndPan() {
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      zoomTo(scale * (e.deltaY < 0 ? 1.15 : 1 / 1.15), e.clientX, e.clientY);
    }, { passive: false });

    var dragging = false, lastX = 0, lastY = 0, moved = 0;

    imgEl.addEventListener('pointerdown', function (e) {
      if (scale <= minScale + 0.01) return;   // only pan while zoomed in
      dragging = true; moved = 0;
      lastX = e.clientX; lastY = e.clientY;
      imgEl.setPointerCapture(e.pointerId);
      e.preventDefault();
    });

    imgEl.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      panX += e.clientX - lastX;
      panY += e.clientY - lastY;
      moved += Math.abs(e.clientX - lastX) + Math.abs(e.clientY - lastY);
      lastX = e.clientX; lastY = e.clientY;
      clampPan();
      applyTransform();
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      if (moved > DRAG_SLOP) suppressClick = true;
      try { imgEl.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    imgEl.addEventListener('pointerup', endDrag);
    imgEl.addEventListener('pointercancel', endDrag);

    // Swipe between images when not zoomed (touch only - a mouse drag at scale
    // 1 shouldn't flick the gallery).
    var startX = 0, startY = 0, swiping = false;
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1 || scale > minScale + 0.01) { swiping = false; return; }
      swiping = true; startX = e.touches[0].clientX; startY = e.touches[0].clientY;
    }, { passive: true });

    stage.addEventListener('touchend', function (e) {
      if (!swiping) return;
      swiping = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - startX, dy = t.clientY - startY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* --- open / navigate / close --------------------------------------------- */

  function show(i) {
    index = (i + slides.length) % slides.length;
    var src = bestSrc(slides[index]);

    overlay.classList.add('is-loading');
    imgEl.style.transform = '';
    imgEl.src = src;
    imgEl.alt = slides[index].alt || '';

    if (imgEl.complete) onLoaded();
    else imgEl.addEventListener('load', onLoaded, { once: true });

    counter.textContent = slides.length > 1 ? (index + 1) + ' / ' + slides.length : '';
    var multi = slides.length > 1;
    prevBtn.hidden = nextBtn.hidden = !multi;
  }

  function onLoaded() {
    overlay.classList.remove('is-loading');
    resetZoom();
  }

  function go(step) {
    if (slides.length > 1) show(index + step);
  }

  function onKey(e) {
    if (e.key === 'Escape')      { close(); }
    else if (e.key === 'ArrowLeft')  { go(-1); }
    else if (e.key === 'ArrowRight') { go(1); }
  }

  function open(gallery, startIndex, trigger) {
    slides = [].slice.call(gallery.querySelectorAll(SLIDE + ' img'));
    if (!slides.length) return;

    openedFrom = trigger || null;
    if (!overlay) build();

    show(startIndex);
    overlay.classList.add('is-open');
    document.documentElement.classList.add('pl-lock');
    document.addEventListener('keydown', onKey);
    overlay.querySelector('.pl-close').focus();
  }

  function close() {
    overlay.classList.remove('is-open', 'is-zoomed');
    document.documentElement.classList.remove('pl-lock');
    document.removeEventListener('keydown', onKey);

    // Leave the on-page gallery showing whatever the shopper ended on.
    try {
      var id = slides[index].closest(SLIDE).getAttribute('data-media-id');
      var thumb = document.querySelector('.product-gallery__thumbnail[data-media-id="' + id + '"]');
      if (thumb) thumb.click();
    } catch (err) {}

    imgEl.removeAttribute('src');
    if (openedFrom && openedFrom.focus) openedFrom.focus();
    openedFrom = null;
  }

  /* --- wiring -------------------------------------------------------------- */

  function bindGallery(gallery) {
    if (gallery.dataset.plBound) return;
    gallery.dataset.plBound = '1';
    gallery.classList.add('pl-enabled');

    // Flickity drags are pointer drags that end in a click. Measure the travel
    // and swallow anything that was really a swipe.
    var downX = 0, downY = 0;
    gallery.addEventListener('pointerdown', function (e) {
      downX = e.clientX; downY = e.clientY;
    }, true);

    gallery.addEventListener('click', function (e) {
      var img = e.target.closest(SLIDE + ' img');
      if (!img) return;
      if (Math.abs(e.clientX - downX) + Math.abs(e.clientY - downY) > DRAG_SLOP) return;

      e.preventDefault();
      e.stopPropagation();

      var imgs = [].slice.call(gallery.querySelectorAll(SLIDE + ' img'));
      open(gallery, imgs.indexOf(img), img);
    });
  }

  function scan() {
    var galleries = document.querySelectorAll(GALLERY);
    for (var i = 0; i < galleries.length; i++) bindGallery(galleries[i]);
  }

  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);

  // Quick-view modals and section re-renders in the theme editor swap the
  // gallery in after load. childList only, and bindGallery is idempotent.
  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();



/* Product page: lift the subtitle metafield up under the title -------------
   The subtitle (a multi_line_text_field metafield) prints in a
   .product-meta__text block below the author + divider, and the theme editor
   can't reorder it because it isn't a section block. This moves ONLY that
   block to sit directly under the title, inside .product-meta.

   CRITICAL: there are usually TWO .product-meta__text blocks on a product -
   the subtitle AND the "This website is based in Israel..." shipping
   disclaimer, which must stay at the bottom. They are told apart by content:
   the subtitle CONTAINS a .metafield-multi_line_text_field span; the
   disclaimer is a plain <p> with none. We select by that span so the
   disclaimer is never touched. (An earlier version selected the first
   .product-meta__text and the MutationObserver then cascaded onto the
   disclaimer too - hence the by-metafield targeting here.)

   Idempotent and safe on products that have no subtitle. */
(function () {
  'use strict';

  function move() {
    var metas = document.querySelectorAll('.product-meta');
    for (var i = 0; i < metas.length; i++) {
      var meta  = metas[i];
      var title = meta.querySelector('.product-meta__title');
      if (!title) continue;

      var form = meta.closest('.product-form') || meta.parentElement;
      // the subtitle is the .product-meta__text that holds the metafield span,
      // never the plain-<p> shipping disclaimer
      var mf  = form.querySelector('.product-meta__text .metafield-multi_line_text_field');
      var sub = mf ? mf.closest('.product-meta__text') : null;

      if (sub && !sub.dataset.subMoved) {
        sub.dataset.subMoved = '1';
        title.insertAdjacentElement('afterend', sub);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', move);
  window.addEventListener('load', move);
  new MutationObserver(move).observe(document.documentElement, { childList: true, subtree: true });
})();



/* Sale badge >= 15% threshold ----------------------------------------------
   Only show the sale badge when the discount is 15% or more, so it stays
   meaningful instead of appearing on every item. Reads the "Save X%" the theme
   already renders and hides the badge when X < 15. Runs on load and on AJAX
   re-renders (carousels, filtering, variant changes). Change MIN to adjust. */
(function () {
  'use strict';
  var MIN = 15;
  function apply() {
    var badges = document.querySelectorAll('.product-label--on-sale');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      if (b.dataset.pctChecked) continue;
      var m = (b.textContent || '').match(/(\d+)\s*%/);
      if (m) {
        b.dataset.pctChecked = '1';
        if (parseInt(m[1], 10) < MIN) b.style.setProperty('display', 'none', 'important');
      }
    }
  }
  document.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('load', apply);
  new MutationObserver(apply).observe(document.documentElement, { childList: true, subtree: true });
})();


/* Binding + Language -> uniform labels & values (display only) --------------
   REPLACES the earlier "Binding only" block you pasted \u2014 paste this over it.

   - Binding: label -> "Binding"; values -> Hardcover / Paperback
   - Language: label -> "Language"; English/Hebrew normalized (English, Hebrew),
     other single languages cleaned (ARA- Arabic -> Arabic, etc.)
   - Works on the product page (selector buttons) AND the cart drawer.

   HEBREW IS WRITTEN AS \uXXXX ESCAPES ON PURPOSE. This keeps the whole file
   pure ASCII so it can't be corrupted by an editor/copy-paste re-encoding
   (which is what turned the Hebrew into mojibake the first time). At runtime
   these escapes become real Hebrew, e.g. "\u05e2\u05d1\u05e8\u05d9\u05ea" is
   the word for "Hebrew".

   Uses EXACT-match tables \u2014 it can only touch a known messy value, never a
   real title. Changes only what's SHOWN; the stored variant value is untouched
   so add-to-cart / pricing keep working. Storefront only (not Shopify's own
   checkout page or order emails). Leaves bilingual languages and binding edge
   cases (Board Book, boxed sets, CD combos) alone.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var BINDING = {
    'hard cover': 'Hardcover', 'hardcover': 'Hardcover', 'hardcomver': 'Hardcover',
    '\u05db\u05e8\u05d9\u05db\u05d4 \u05e7\u05e9\u05d4': 'Hardcover', // "kricha kasha"
    '\u05e7\u05e9\u05d4': 'Hardcover',                             // "kasha"
    'soft cover': 'Paperback', 'paperback': 'Paperback', 'paper back': 'Paperback',
    '\u05db\u05e8\u05d9\u05db\u05d4 \u05e8\u05db\u05d4': 'Paperback' // "kricha racha"
  };
  // Hebrew output value = "\u05e2\u05d1\u05e8\u05d9\u05ea"
  var HE = '\u05e2\u05d1\u05e8\u05d9\u05ea';
  var LANG = {
    'english': 'English', 'englsih': 'English', 'eng- english': 'English',
    'eng-us- english (united states)': 'English',
    'hebrew': HE, 'heb- hebrew': HE,
    'hebrew \u05e2\u05d1\u05e8\u05d9\u05ea': HE,       // "hebrew HE"
    'hebrew / \u05e2\u05d1\u05e8\u05d9\u05ea': HE,     // "hebrew / HE"
    '\u05e2\u05d1\u05e8\u05d9\u05ea': HE,              // HE alone
    '\u05e2\u05e8\u05d9\u05ea hebrew': HE,             // typo "arit hebrew"
    'ara- arabic': 'Arabic', 'ces- czech': 'Czech', 'deu- german': 'German',
    'espa\u00f1ol': 'Spanish', 'french': 'French', 'russian': 'Russian', 'spanish': 'Spanish'
  };
  function look(map, v) { return map[(v || '').trim().toLowerCase()] || null; }

  var RULES = [
    { test: function (n) { return /cover|binding|\u05db\u05e8\u05d9\u05db\u05d4/i.test(n); }, label: 'Binding', map: BINDING },
    { test: function (n) { return /lang|\u05e9\u05e4\u05d4/i.test(n) || /^(english|hebrew|\u05e2\u05d1\u05e8\u05d9\u05ea)$/i.test(n); }, label: 'Language', map: LANG }
  ];
  function ruleFor(name) { for (var i = 0; i < RULES.length; i++) if (RULES[i].test(name)) return RULES[i]; return null; }
  function setText(node, val) { if (node && node.textContent !== val) node.textContent = val; }

  function fixOptions() {
    var opts = document.querySelectorAll('.product-form__option');
    for (var i = 0; i < opts.length; i++) {
      var opt = opts[i], nameEl = opt.querySelector('.product-form__option-name');
      if (!nameEl) continue;
      var textNode = null;
      for (var j = 0; j < nameEl.childNodes.length; j++) {
        var n = nameEl.childNodes[j];
        if (n.nodeType === 3 && n.textContent.trim()) { textNode = n; break; }
      }
      if (!textNode) continue;
      var rule = ruleFor(textNode.textContent.replace(/:\s*$/, '').trim());
      if (!rule) continue;
      setText(textNode, rule.label + ': ');
      var sel = nameEl.querySelector('.product-form__selected-value');
      if (sel) { var nv = look(rule.map, sel.textContent); if (nv) setText(sel, nv); }
      var labels = opt.querySelectorAll('.block-swatch__item');
      for (var k = 0; k < labels.length; k++) {
        var lv = look(rule.map, labels[k].textContent);
        if (lv) setText(labels[k], lv);
      }
    }
  }

  function fixCart() {
    var titles = document.querySelectorAll('.mini-cart__product-title, [class*="product-title"]');
    for (var i = 0; i < titles.length; i++) {
      var a = titles[i];
      for (var j = 0; j < a.childNodes.length; j++) {
        var n = a.childNodes[j];
        if (n.nodeType !== 3) continue;
        var t = n.textContent, idx = t.lastIndexOf(' - ');
        if (idx < 0) continue;
        var base = t.slice(0, idx), suffix = t.slice(idx + 3);
        var nv = look(BINDING, suffix) || look(LANG, suffix);
        if (nv && nv !== suffix.trim()) n.textContent = base + ' - ' + nv;
      }
    }
  }

  function apply() { fixOptions(); fixCart(); }
  document.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('load', apply);
  document.addEventListener('change', function () { setTimeout(apply, 30); });
  new MutationObserver(apply).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ==========================================================================
   GEFEN ISRAEL - cross-store switcher (map + logic).
   Paired with the styles at the end of custom.css and the
   israel-store-flag snippet rendered in the header.
   Regenerate the map with: node tools/build-map.mjs
   ========================================================================== */
/* Generated by tools/build-map.mjs on 2026-08-05 - do not edit by hand.
   281 of 2272 US products have an Israeli counterpart.
   Re-run the script and re-upload this file when either catalogue changes. */
window.GefenIsraelMap = {
  generatedOn: "2026-08-05",
  products: {
    "shas-mehadoret-sida-laderech-33-vol": "שס-כיס-מהדורת-צידה-לדרך-33-כר-גודל-17-12",
    "shas-chataniim-hachadash-zachar-chanuch-22-vol": "שס-חתנים-החדש-זכר-חנוך-22-כר",
    "shas-nehardeah-hachadash-22-vol-kollel-zeraim-tahorot": "שס-נהרדעא-החדש-22-כר",
    "shas-uvlechtecha-baderech-20-vol": "שס-ובלכתך-בדרך-20-כ-כריכה-קשה",
    "siman-labanim": "siman-labanim-two-volume-set",
    "the-history-of-christian-zionism-vol-2": "תולדות-הציונות-הנוצרית-כרך-ב",
    "guide-for-the-kosher-traveler-hebrew": "guide-for-the-kosher-traveler-מדריך-למטייל-הכשר",
    "guide-for-the-kosher-traveler": "guide-for-the-kosher-traveler-מדריך-למטייל-הכשר",
    "report-israel": "report-israel-black-and-white-photography",
    "hatoof": "חטוף",
    "mans-search-for-identity": "האדם-מחפש-זהות-מאת-משה-פייגלין",
    "divrei-halev-words-from-the-heart": "divrei-halev-from-the-heart_דברי-הלב-של-דויד-וייס-הלבני",
    "pirkei-hallel-a-shared-journey-for-bat-mitzvah-girls-and": "pirkei-hallel-a-shared-journey-for-bat-mitzvah-girls-and-their-mothers",
    "a-guide-for-life-through-the-eyes-of-the-book-of-esther": "a-guide-for-life-through-the-eyes-of-megillat-esther",
    "a-handbook-for-keeping-kosher-hebrew": "מדריך-לשמורת-כשרות",
    "a-guide-for-life-through-the-eyes-of-the-book-of-esther-hebrew": "מסרים-ומדריך-לחיים-מתוך-עיני-מגילת-אסתר",
    "the-book-of-genesis-with-insights-and-commentary-from-500": "the-book-of-genesis-with-insights-and-commentary-from-500-sages-and-mystics",
    "my-israeli-journey-hebrew": "my-israeli-journey",
    "a-handbook-for-keeping-kosher": "מדריך-לשמורת-כשרות",
    "cooking-together-the-israeli-pantry": "cooking-together",
    "marry-a-mensch": "marry-a-mentsch",
    "touching-history-hebrew": "בתוך-עמי-אני-יושב-touching-history",
    "be-a-blessing-hebrew": "be-a-blessing",
    "sights": "in-sights-thirty-years-of-peacemaking-in-the-olso-process",
    "heaven-and-earth-volume-3": "heaven-and-earth-3-volume-boxed-set",
    "the-luck-of-a-jew-will-be-great": "the-luck-of-a-jew-will-be-great-hebrew",
    "a-tale-of-five-balloons": "a-tale-of-five-balloons-hard-cover",
    "my-israel": "my-israel-seventy-faces-of-the-land",
    "the-two-little-overseers-of-the-synagogue": "שני-גבאי-קטנים",
    "the-book-of-esther": "the-book-of-esther-a-commentary-and-history",
    "mysteries-of-judaism-volume-v": "mysteries-of-judaism-v",
    "pumpkin-the-kitten-hebrew": "pumpkin-the-kitten",
    "herzls-vision-today": "herzl-s-vision-today",
    "hidden-heroes-paperback-edition": "hidden-heroes",
    "the-poetry-of-rav-yosef-tzvi-rimon": "the-poetry-of-rav-yosef-tzvi-rimon-a-myrtle-in-the-desert",
    "devilspel": "קסמי-השטן",
    "we-are-from-jaffa": "אנחנו-מיפו",
    "islam-and-judaism": "האסלאם-והיהדות-המאחד-והמפריד",
    "who-murdered-yitzchak-rabin": "кто-убил-ицхака-рабина-who-murdered-yitzchak-rabin",
    "almaz-walks-down-the-paths-of-her-childhood-hebrew": "אלמז-פוסעת-בשבילי-ילדותה-almaz-walks-down-the-paths-of-her-childhood",
    "almaz-walks-down-the-paths-of-her-childhood": "אלמז-פוסעת-בשבילי-ילדותה-almaz-walks-down-the-paths-of-her-childhood",
    "heartbeats": "heartbeats-the-insiders-guide-to-israel",
    "hitmodedut": "התמודדות",
    "siamo-qui-siamo-vivi-we-are-here-alive": "אנחנו-כאן-בחיים",
    "fear-no-evil": "לא-אירא-רע",
    "a-night-at-the-playground-hebrew": "a-night-at-the-playground",
    "hijack-for-freedom": "hijack-for-freedom-the-memoirs-of-mark-dymshits-soviet-pilot-jew-breacher-of-the-iron-curtain",
    "when-and-how-the-arabs-and-muslims-immigrated-to-the-land": "when-and-how-the-arabs-and-muslims-immigrated-to-the-land-of-israel",
    "guilt-by-accusation": "אשם-על-סמך-הַאֲשָמָה",
    "titus-trump-and-the-triumph-of-israel-hc": "titus-trump-and-the-triumph-of-israel-the-power-of-faith-based-diplomacy",
    "lone-voice": "lone-voice-the-wars-of-isi-leibler",
    "the-antiphonary-of-love": "the-antiphonary-of-love-the-call-of-the-scroll",
    "israel-for-beginners-french": "israel-pour-les-debutants",
    "a-shelter-for-ghosts": "מקלט-לרוחות",
    "stories-of-a-building-contractor": "סיפורים-של-קבלן-בניין",
    "shurot": "שורות-דוד-אליאך",
    "sacred-monsters-hebrew": "sacred-monsters",
    "memories-of-jewish-poland": "memories-of-jewish-poland-the-1932-photographs-of-nahum-tim-gidal",
    "the-rage-less-traveled": "the-rage-less-traveled-a-memoir-of-surviving-a-machete-attack",
    "i-lived-a-thousand-years": "חייתי-אלף-שנים",
    "fateful-dna": "dna-גורלי",
    "theodor-herzl-a-new-reading-hebrew": "theodor-herzl-a-new-reading",
    "multi-dictionary-for-russian-speakers": "multi-dictionary-rav-milon-for-english-french-russian-and-hebrew",
    "snow-flowers": "פרחים-בשלג",
    "tintin-comics-in-hebrew-destination-moon": "הרפתקאותיו-של-טינטין-הטיסה-לירח",
    "faith-at-the-brink": "אמונה-על-סף-התהום",
    "ivrit-esre-part-3": "ivrit-esreh-book-3",
    "ivrit-esre-part-2": "ivrit-esreh-book-2",
    "ivrit-esre-part-1": "ivrit-esreh-book-1",
    "shma-tefilati-prayer-book-for-children": "שמע-תפילתי",
    "follow-me-hebrew": "follow-me",
    "phantom-nation": "phantom-nation-2-volume-set",
    "the-lies-they-tell": "lies-they-tell",
    "sister-of-zion-hebrew": "אחות-ציון_sister-of-zion",
    "five-seasons-in-the-kitchen-hebrew": "five-seasons-in-the-kitchen",
    "yonis-last-battle": "yoni-s-last-battle",
    "and-every-single-one-was-someone-hc": "and-every-single-one-was-someone",
    "seashell-queen-volume-1-to-the-light": "מלכת-הקונכייה-אל-האור",
    "seashell-queen-volume-3-victory-of-spirit": "מלכת-הקונכייה-ניצחון-הרוח",
    "seashell-queen-volume-2-sunrise": "מלכת-הקונכייה-זריחה-ושקיעה",
    "the-unofficial-harry-potter-cookbook": "ספר-הבישול-הבלתי-רשמי-של-הארי-פוטר",
    "pirkei-avos-with-a-twist-of-humor-sc": "pirkei-avos-with-a-twist-of-humor",
    "itamar-makes-friends-hebrew": "איתמר-רוכש-ידידים-חדשים-itamar-makes-friends",
    "speaking-arabic": "speaking-arabic-4-books-and-5-cds",
    "the-newlyweds-guide-to-physical-intimacy-et-le-ehov": "עת-תאהוב-the-newlywed-guide-to-physical-intimacy",
    "unlocking-the-torah-text-shmot-us-release-december-2008": "unlocking-the-torah-text-shmot",
    "fifty-jewish-messiahs": "50-jewish-messiahs",
    "perfidy": "perfidy-כחש",
    "theres-cancer-in-the-house": "יש-סרטן-בבית",
    "jewish-nation-of-the-caribbean": "בני-האומההיהודית-באיזור-הקריבי",
    "the-guide-for-guides-a-tour-guide-manual": "the-guide-for-guides",
    "but-he-was-good-to-his-mother-hebrew": "but-he-was-good-to-his-mother",
    "fragments-of-memory-russian": "fragments-of-memory-רצח-ביום-כיפור-z-kolina-do-jerusalema",
    "pirkei-avos-with-a-twist-of-humor-hc": "pirkei-avos-with-a-twist-of-humor",
    "ish-kash": "אישקש",
    "harry-potter-and-the-order-of-the-phoenix": "הארי-פוטר-ומסדר-עוף-החול",
    "harry-potter-and-the-goblet-of-fire": "הארי-פוטר-וגביע-האש",
    "harry-potter-and-the-prisoner-of-azkaban": "הארי-פוטר-והאסיר-מאזקבאן",
    "is-god-sad-hebrew": "אז-מה-זה-אלהים-is-god-sad",
    "the-lion-that-loved-strawberries": "האריה-שאהב-תות",
    "studies-in-the-weekly-sidra-7-volumes": "studies-in-the-weekly-sidra-7-volumes-english",
    "mishnah-kehati-hebrew-english-21-volume-large-hard-cover-set": "mishnayot-kehati-hebrew-english-21-volumes",
    "yom-kippur-childrens-machzor-hebrew": "yom-kippur-childrens-machzor-מחזור-יום-הכיפורים-לילדים"
  },
  collections: [
    "anti-semitism",
    "biography",
    "frontpage",
    "historical-fiction",
    "learn-hebrew",
    "marriage-and-relationships"
  ]
};
window.dispatchEvent(new CustomEvent('gefen:israel-map-ready'));

/**
 * Israeli-store switcher for the US storefront.
 *
 * Sends a visitor from a page on the US store to the equivalent page on
 * israelbooks.com. A product is matched three ways, cheapest first:
 *
 *   1. gefen-israel-map.js, a build-time table of US handle -> Israeli handle.
 *      Covers the books whose handles differ between the stores (Hebrew titles,
 *      renamed handles) and costs no network request.
 *   2. A live lookup of /products/<handle>.js on the Israeli store, which
 *      catches anything published there since the map was last generated.
 *   3. Failing both, the Israeli home page.
 *
 * The lookup is deferred until the visitor shows intent (hover, focus, or touch
 * on the flag), so an ordinary page view costs nothing.
 */
(function () {
  'use strict';

  var CFG = window.GefenIsraelConfig || {};
  var IL = String(CFG.origin || 'https://israelbooks.com').replace(/\/+$/, '');
  var HOME = IL + '/';
  var LOOKUP_TIMEOUT = 2500;
  var BANNER_DISMISS_DAYS = 90;
  var CACHE_PREFIX = 'gefen-il:';

  /* ---------------------------------------------------------------- utils */

  function path(kind, handle) {
    // Hebrew handles have to be percent-encoded to survive as a URL.
    return IL + '/' + kind + '/' + encodeURIComponent(handle);
  }

  function cacheGet(key) {
    try {
      return window.sessionStorage.getItem(CACHE_PREFIX + key);
    } catch (e) {
      return null;
    }
  }

  function cacheSet(key, value) {
    try {
      window.sessionStorage.setItem(CACHE_PREFIX + key, value);
    } catch (e) {
      /* private mode, quota - not worth caring about */
    }
  }

  function map() {
    return window.GefenIsraelMap || null;
  }

  /**
   * True if the handle resolves to a real product on the Israeli store.
   * /products/<handle>.js answers 200 or 404 and, unlike the search and
   * collection endpoints, is readable cross-origin.
   */
  function existsOnIsraeliStore(handle) {
    if (!window.fetch || !window.AbortController) return Promise.resolve(false);

    var controller = new AbortController();
    var timer = window.setTimeout(function () {
      controller.abort();
    }, LOOKUP_TIMEOUT);

    return window
      .fetch(path('products', handle) + '.js', {
        signal: controller.signal,
        credentials: 'omit',
        // A HEAD would be cheaper but Shopify answers it inconsistently.
        method: 'GET',
      })
      .then(function (res) {
        return res.ok;
      })
      .catch(function () {
        return false;
      })
      .then(function (result) {
        window.clearTimeout(timer);
        return result;
      });
  }

  /* ------------------------------------------------------------ resolving */

  var resolved = null; // cached promise for this page view

  function resolve() {
    if (resolved) return resolved;

    var cacheKey = window.location.pathname;
    var cached = cacheGet(cacheKey);
    if (cached) {
      resolved = Promise.resolve(cached);
      return resolved;
    }

    resolved = compute().then(function (url) {
      cacheSet(cacheKey, url);
      return url;
    });
    return resolved;
  }

  function compute() {
    var m = map();

    if (CFG.pageType === 'product' && CFG.productHandle) {
      var mapped = m && m.products ? m.products[CFG.productHandle] : null;
      if (mapped) return Promise.resolve(path('products', mapped));

      return existsOnIsraeliStore(CFG.productHandle).then(function (exists) {
        return exists ? path('products', CFG.productHandle) : HOME;
      });
    }

    if (CFG.pageType === 'collection' && CFG.collectionHandle) {
      // Collections have no cross-origin existence check, so the build-time
      // list is the only evidence available.
      var known = m && m.collections && m.collections.indexOf(CFG.collectionHandle) !== -1;
      return Promise.resolve(known ? path('collections', CFG.collectionHandle) : HOME);
    }

    // Cart, search, account, articles, policies and everything else have no
    // meaningful counterpart - send them to the Israeli home page.
    return Promise.resolve(HOME);
  }

  /**
   * Point a link at the Israeli equivalent, resolving lazily. The href starts
   * as the home page so the link is never broken, then upgrades in place once
   * the real target is known.
   */
  function bind(link) {
    if (!link || link.dataset.gefenIlBound) return;
    link.dataset.gefenIlBound = '1';
    link.setAttribute('href', HOME);

    var upgraded = false;

    function upgrade() {
      return resolve().then(function (url) {
        if (!upgraded) {
          link.setAttribute('href', url);
          upgraded = true;
        }
        return url;
      });
    }

    // Start work as soon as the visitor looks like they mean it.
    ['pointerenter', 'focus', 'touchstart', 'pointerdown'].forEach(function (evt) {
      link.addEventListener(evt, upgrade, { passive: true, once: false });
    });

    // If they click before the lookup finished, hold the navigation briefly
    // rather than sending them somewhere wrong.
    link.addEventListener('click', function (event) {
      if (upgraded) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      event.preventDefault();
      upgrade().then(function (url) {
        window.location.href = url;
      });
    });
  }

  /* -------------------------------------------------------------- banner */

  function dismissedRecently() {
    try {
      var until = parseInt(window.localStorage.getItem('gefen-il-banner-dismissed-until'), 10);
      return !!until && Date.now() < until;
    } catch (e) {
      return false;
    }
  }

  function rememberDismissal() {
    try {
      var until = Date.now() + BANNER_DISMISS_DAYS * 24 * 60 * 60 * 1000;
      window.localStorage.setItem('gefen-il-banner-dismissed-until', String(until));
    } catch (e) {
      /* nothing useful to do */
    }
  }

  /**
   * Shopify's own geolocation endpoint, served from this store's origin. No
   * third-party service, no extra script, and it reflects the same IP data
   * Shopify Markets uses.
   */
  function visitorIsInIsrael() {
    if (window.location.search.indexOf('gefen_il_preview=1') !== -1) {
      return Promise.resolve(true);
    }
    if (!window.fetch) return Promise.resolve(false);

    return window
      .fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        var detected = data && data.detected_values && data.detected_values.country;
        return !!detected && detected.handle === 'IL';
      })
      .catch(function () {
        return false;
      });
  }

  function setUpBanner(banner) {
    if (!banner) return;
    if (dismissedRecently()) return;

    visitorIsInIsrael().then(function (inIsrael) {
      if (!inIsrael) return;

      var link = banner.querySelector('[data-gefen-il-link]');
      bind(link);
      resolve().then(function (url) {
        if (link) link.setAttribute('href', url);
      });

      var close = banner.querySelector('[data-gefen-il-dismiss]');
      if (close) {
        close.addEventListener('click', function () {
          banner.hidden = true;
          rememberDismissal();
        });
      }

      banner.hidden = false;
      document.documentElement.classList.add('gefen-il-banner-visible');
    });
  }

  /* ----------------------------------------------------------------- init */

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-gefen-il-flag]'), bind);
    setUpBanner(document.querySelector('[data-gefen-il-banner]'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
})();
